import { ProposalOptionsItemProps } from "@repo/core/screens/Proposals/screens/ProposalsSearch/components/ProposalOptionsSheet/ProposalOptionsItem/types";

export const documentActionOptions: Omit<
  ProposalOptionsItemProps,
  "onPress"
>[] = [
  {
    label: "Tirar uma foto",
    icon: "camera",
    action: "$captureImage"
  },
  {
    label: "Enviar de um arquivo",
    icon: "share-up",
    action: "$uploadFile"
  }
];
